// /*********************
//  * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
//  * __________________
//  *
//  *  Mobillor Technologies Pvt. Ltd.
//  *  All Rights Reserved.
//  *
//  * NOTICE:  All information contained herein is, and remains
//  * the property of Mobillor Technologies Pvt. Ltd.
//  * The intellectual and technical concepts contained
//  * herein are proprietary to Mobillor Technologies Pvt. Ltd.
//  * may be covered by Rebublic Of India and Foreign Patents,
//  * patents in process, and are protected by trade secret or copyright law.
//  * Dissemination of this information or reproduction of this material
//  * is strictly forbidden unless prior written permission is obtained
//  * from Mobillor Technologies Pvt. Ltd.
//  */

import { useEffect, useRef, useState } from "react";
import ReactMarkdown from "react-markdown";
import { connect } from "react-redux";
import remarkGfm from "remark-gfm";

import DarkModeRoundedIcon from "@mui/icons-material/DarkModeRounded";
import LightModeRoundedIcon from "@mui/icons-material/LightModeRounded";
import {
  Avatar,
  Box,
  Button,
  Chip,
  Fade,
  IconButton,
  InputBase,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Modal,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";

import Cookies from "universal-cookie";

// Icons
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import InsertDriveFileRoundedIcon from "@mui/icons-material/InsertDriveFileRounded";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
// NEW ICONS FOR TOGGLE
import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import DeleteSweepRoundedIcon from "@mui/icons-material/DeleteSweepRounded";

// Components & Assets
import aiLogo from "../../../assets/aiLogo.png";
import miniIcon from "../../../assets/newIcon.jpg";
import UniversalChart from "../Universal-Chart/index";
import ChatInput from "./ChatInput";

// Cookies
import {
  clearAllSessions,
  createNewSession,
  // createSessionReducer,
  // getSessionHistoryReducer,
  deleteSession,
  getAllSessions,
  getSessionHistory,
  getSubModulesByRoleId,
  sendMessage,
} from "../../../store";

import Config from "../../../config/index";
const cookies = new Cookies();

const parseDeepJSON = (input) => {
  try {
    if (typeof input === "object" && input?.response?.result) {
      const inner = input.response.result;
      return typeof inner === "string" ? JSON.parse(inner) : inner;
    }
    if (typeof input === "string") {
      const match = input.match(/\[.*\]/s) || input.match(/\{.*\}/s);
      if (match) return JSON.parse(match[0]);
    }
    return input;
  } catch (e) {
    return null;
  }
};

// const prepareChartData = (apiResponse) => {
//   try {
//     let rawData = parseDeepJSON(apiResponse);
//     if (rawData && !Array.isArray(rawData) && Array.isArray(rawData.data)) {
//       rawData = rawData.data;
//     }
//     if (!Array.isArray(rawData) || rawData.length === 0) return null;

//     const sampleItem = rawData[0];
//     const keys = Object.keys(sampleItem);

//     const labelKey =
//       keys.find(
//         (k) =>
//           k.toLowerCase().includes("number") || k.toLowerCase().includes("id")
//       ) ||
//       keys.find((k) => k.toLowerCase().includes("date")) ||
//       keys[0];
//     const valueKey = keys.find((key) =>
//       rawData.some((item) => typeof item[key] === "number")
//     );

//     return {
//       chartData: rawData.map((item, index) => ({
//         name: item[labelKey] || `Item ${index + 1}`,
//         value: valueKey ? Number(item[valueKey]) : 1,
//         original: item,
//       })),
//       title: valueKey ? `${valueKey} by ${labelKey}` : `Records by ${labelKey}`,
//       dataKey: "value",
//     };
//   } catch (error) {
//     console.error("Chart Transform Failed:", error);
//     return null;
//   }
// };

// --- HELPER: Prepare Chart Data (Smart Version) ---

// const prepareChartData = (apiResponse) => {
//   try {
//     let rawData = parseDeepJSON(apiResponse);
//     if (rawData && !Array.isArray(rawData) && Array.isArray(rawData.data)) {
//       rawData = rawData.data;
//     }
//     if (!Array.isArray(rawData) || rawData.length === 0) return null;

//     const sampleItem = rawData[0];
//     const keys = Object.keys(sampleItem);

//     const valueKey = keys.find((key) =>
//       rawData.some((item) => {
//         const val = item[key];
//         return (
//           typeof val === "number" ||
//           (!isNaN(Number(val)) && val !== "" && val !== null)
//         );
//       })
//     );

//     const labelKey =
//       keys.find((key) => {
//         if (key === valueKey) return false;
//         const k = key.toLowerCase();
//         return (
//           k.includes("date") ||
//           k.includes("time") ||
//           k.includes("day") ||
//           k.includes("month") ||
//           k.includes("year")
//         );
//       }) ||
//       keys.find((key) => {
//         if (key === valueKey) return false;
//         const k = key.toLowerCase();
//         return (
//           k.includes("name") ||
//           k.includes("title") ||
//           k.includes("code") ||
//           k.includes("id")
//         );
//       }) ||
//       keys.find((k) => k !== valueKey);

//     if (!valueKey || !labelKey) return null;

//     // 3. Data Transformation & Cleaning
//     let processedData = rawData.map((item, index) => {
//       let nameValue = item[labelKey];
//       if (labelKey.toLowerCase().match(/date|time|day/)) {
//         const dateObj = new Date(nameValue);
//         if (!isNaN(dateObj.getTime())) {
//           nameValue = dateObj.toLocaleDateString("en-US", {
//             day: "numeric",
//             month: "short",
//           });
//         }
//       }

//       return {
//         name: nameValue || `Item ${index + 1}`,
//         value: Number(item[valueKey]),
//         fullDate: item[labelKey],
//         original: item,
//       };
//     });

//     if (labelKey.toLowerCase().match(/date|time|day/)) {
//       processedData.sort((a, b) => new Date(a.fullDate) - new Date(b.fullDate));
//     }

//     return {
//       chartData: processedData,
//       title: `${valueKey} Analysis`,
//       dataKey: valueKey,
//     };
//   } catch (error) {
//     console.error("Chart Transform Failed:", error);
//     return null;
//   }
// };

const prepareChartData = (apiResponse) => {
  try {
    let rawData = parseDeepJSON(apiResponse);
    if (rawData && !Array.isArray(rawData) && Array.isArray(rawData.data)) {
      rawData = rawData.data;
    }
    if (!Array.isArray(rawData) || rawData.length === 0) return null;

    const sampleItem = rawData[0];
    const keys = Object.keys(sampleItem);

    // 1. Find Value Key (Y-Axis)
    const valueKey = keys.find((key) =>
      rawData.some((item) => {
        const val = item[key];
        return (
          typeof val === "number" ||
          (!isNaN(Number(val)) && val !== "" && val !== null)
        );
      }),
    );

    // 2. Find Label Key (X-Axis)
    const labelKey =
      keys.find((key) => {
        if (key === valueKey) return false;
        const k = key.toLowerCase();
        return (
          k.includes("date") ||
          k.includes("time") ||
          k.includes("day") ||
          k.includes("month") ||
          k.includes("year")
        );
      }) ||
      keys.find((key) => {
        if (key === valueKey) return false;
        const k = key.toLowerCase();
        return (
          k.includes("name") ||
          k.includes("title") ||
          k.includes("code") ||
          k.includes("id")
        );
      }) ||
      keys.find((k) => k !== valueKey);

    if (!valueKey || !labelKey) return null;
    let processedData = rawData.map((item, index) => {
      let nameValue = item[labelKey];

      if (labelKey.toLowerCase().match(/date|time|day/)) {
        const dateObj = new Date(nameValue);
        if (!isNaN(dateObj.getTime())) {
          const hasTime =
            dateObj.getHours() !== 0 || dateObj.getMinutes() !== 0;

          const options = {
            day: "numeric",
            month: "short",
            ...(hasTime && { hour: "2-digit", minute: "2-digit" }),
          };

          nameValue = dateObj.toLocaleDateString("en-US", options);
        }
      }

      return {
        // name: nameValue || `Item ${index + 1}`,
        name: `${nameValue}__${index}`,
        displayName: nameValue,
        value: Number(item[valueKey]),
        fullDate: item[labelKey],
        original: item,
      };
    });

    if (labelKey.toLowerCase().match(/date|time|day/)) {
      processedData.sort((a, b) => new Date(a.fullDate) - new Date(b.fullDate));
    }

    return {
      chartData: processedData,
      title: `${valueKey} Analysis`,
      dataKey: valueKey,
    };
  } catch (error) {
    console.error("Chart Transform Failed:", error);
    return null;
  }
};

const parseMarkdownTable = (text) => {
  try {
    const tableRegex = /(\|.*\|(?:\r?\n\|.*\|)*)/s;
    const match = text.match(tableRegex);
    if (!match) return null;

    const tableBlock = match[0];
    const lines = tableBlock.trim().split("\n");
    if (lines.length < 2) return null;

    const parseLine = (line) => {
      let content = line.trim();
      if (content.startsWith("|")) content = content.substring(1);
      if (content.endsWith("|"))
        content = content.substring(0, content.length - 1);
      return content.split("|").map((cell) => cell.trim());
    };

    const headers = parseLine(lines[0]);
    const data = [];

    for (let i = 1; i < lines.length; i++) {
      const line = lines[i].trim();
      if (line.includes("---") || !line.includes("|")) continue;

      const values = parseLine(line);
      const rowObj = {};
      headers.forEach((header, index) => {
        const val = values[index] || "";
        rowObj[header] = isNaN(Number(val)) ? val : Number(val);
      });
      data.push(rowObj);
    }
    return data.length > 0 ? data : null;
  } catch (e) {
    return null;
  }
};

export const detectResponseType = (content) => {
  try {
    let structuredData = null;

    if (typeof content === "object" && content !== null) {
      structuredData = content;
    } else if (typeof content === "string") {
      const match = content.match(/\[.*\]/s) || content.match(/\{.*\}/s);
      if (match) structuredData = JSON.parse(match[0]);
    }

    let cleanData = Array.isArray(structuredData)
      ? structuredData
      : structuredData?.data || structuredData?.result;

    if (!cleanData || !Array.isArray(cleanData)) {
      if (typeof content === "string") {
        const markdownData = parseMarkdownTable(content);
        if (markdownData) cleanData = markdownData;
      }
    }

    if (Array.isArray(cleanData) && cleanData.length > 0) {
      const prepared = prepareChartData(cleanData);

      if (prepared) {
        return {
          type: "structured",
          originalData: cleanData,
          chartData: prepared.chartData,
          title: prepared.title,
          dataKey: prepared.dataKey,
        };
      }

      return { type: "table", data: cleanData };
    }

    return { type: "text", data: content };
  } catch (e) {
    return { type: "text", data: content };
  }
};

const Typewriter = ({ text }) => {
  const [displayedText, setDisplayedText] = useState("");

  useEffect(() => {
    let index = 0;
    setDisplayedText("");
    const intervalId = setInterval(() => {
      setDisplayedText((prev) => prev + text.charAt(index));
      index++;
      if (index === text.length) {
        clearInterval(intervalId);
      }
    }, 10);

    return () => clearInterval(intervalId);
  }, [text]);

  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      sx={{ fontFamily: "Arial, sans-serif" }}
    >
      {displayedText}
    </ReactMarkdown>
  );
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
  pt: 3,
  borderRadius: "12px",
  outline: "none",
  fontFamily: "Cambria, serif",
};

const ChatPageCopy = ({
  onBack,
  initialPrompt,
  onPromptExecuted,
  sendMessage,
  getAllSessions,
  getAllSessionsReducer,
  getSessionHistory,
  createNewSession,
  getSessionHistoryReducer,
  deleteSession,
  mode,
  toggleColorMode,
  clearAllSessions,
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let userId = loginDetails?.data.userId;
  let roleName = loginDetails.data.roleName;
  let roleId = loginDetails.data.roleId;
  let email = loginDetails.data.email;

  let baseUrl = Config.baseUrl;
  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let aiChatBotModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "c38f4dce-6ce0-4812-8a82-c55a5e28a616",
  );
  let chatAccess = aiChatBotModule
    ? aiChatBotModule.actionId.includes("2cc4aa6a-81f4-4137-9f63-445c37b8a7b8")
    : null;

  const [inputValue, setInputValue] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [isTyping, setIsTyping] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [clearAllOpen, setClearAllOpen] = useState(false);

  const fileInputRef = useRef(null);
  const messagesEndRef = useRef(null);

  useEffect(() => {
    getAllSessions(userId);
  }, []);

  useEffect(() => {
    if (initialPrompt) {
      handleSend(initialPrompt);
      if (onPromptExecuted) {
        onPromptExecuted();
      }
    }
  }, [initialPrompt]);

  // date session

  useEffect(() => {
    const defaultSessionObj = {
      id: "new_chat",
      title: "New Chat",
      messages: [
        {
          // id: 1,
          // text: "Hi! I'm MOBY. How can I help you today?",
          // sender: "bot",
          id: "hidden_init",
          text: "Hidden Init",
          sender: "bot",
          isHidden: true,
          type: "text",
          timestamp: new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          }),
        },
      ],
      // messages: [],
    };

    const rawData = getAllSessionsReducer?.sessionsList;
    const apiData = Array.isArray(rawData) ? rawData : [];

    setSessions((prevSessions) => {
      const historySessions = apiData.map((sessionItem) => {
        const dateTitle = sessionItem.lastUpdateTime
          ? new Date(sessionItem.lastUpdateTime * 1000).toLocaleDateString(
              "en-GB",
              {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              },
            )
          : "Saved Chat";

        const existingSession = prevSessions.find(
          (s) => String(s.id) === String(sessionItem.id),
        );

        return {
          id: String(sessionItem.id),
          title:
            existingSession?.title && existingSession.title !== "New Chat"
              ? existingSession.title
              : `Chat-${dateTitle}`,
          messages: existingSession?.messages || [],
        };
      });

      historySessions.reverse();

      let finalDefaultObj = defaultSessionObj;
      const existingNewChat = prevSessions.find((s) => s.id === "new_chat");
      if (existingNewChat && existingNewChat.messages.length > 1) {
        finalDefaultObj = existingNewChat;
      }

      return [finalDefaultObj, ...historySessions];
    });
  }, [getAllSessionsReducer.sessionsList]);

  const [sessions, setSessions] = useState([
    {
      id: "new_chat",
      title: "New Chat",
      messages: [
        {
          // id: 1,
          // text: "Hi! I'm MOBY. How can I help you today?",
          // sender: "bot",
          id: "hidden_init",
          text: "Hidden Init",
          sender: "bot",
          isHidden: true,
          type: "text",
          timestamp: new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          }),
        },
      ],
      // messages:[]
    },
  ]);

  const [activeSessionId, setActiveSessionId] = useState("new_chat");

  const currentSession =
    sessions.find((s) => s.id === activeSessionId) || sessions[0];

  const filteredSessions = sessions.filter((session) =>
    session.title.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  const showHero = currentSession.messages.length <= 1;

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  // const parseMarkdownTable = (text) => {
  //   try {
  //     const tableRegex = /(\|.*\|(?:\r?\n\|.*\|)*)/s;
  //     const match = text.match(tableRegex);
  //     if (!match) return null;

  //     const tableBlock = match[0];
  //     const lines = tableBlock.trim().split("\n");
  //     if (lines.length < 2) return null;

  //     const parseLine = (line) => {
  //       let content = line.trim();
  //       if (content.startsWith("|")) content = content.substring(1);
  //       if (content.endsWith("|"))
  //         content = content.substring(0, content.length - 1);
  //       return content.split("|").map((cell) => cell.trim());
  //     };

  //     const headers = parseLine(lines[0]);
  //     if (headers.length === 0) return null;

  //     const data = [];
  //     for (let i = 1; i < lines.length; i++) {
  //       const line = lines[i].trim();
  //       if (line.includes("---")) continue;
  //       if (!line.includes("|")) continue;
  //       const values = parseLine(line);
  //       const rowObj = {};
  //       headers.forEach((header, index) => {
  //         rowObj[header] = values[index] || "";
  //       });
  //       data.push(rowObj);
  //     }
  //     return data.length > 0 ? data : null;
  //   } catch (e) {
  //     return null;
  //   }
  // };

  const parseMarkdownTable = (text) => {
    try {
      const tableRegex = /(\|.*\|(?:\r?\n\|.*\|)*)/s;
      const match = text.match(tableRegex);
      if (!match) return null;

      const tableBlock = match[0];
      const lines = tableBlock.trim().split("\n");
      if (lines.length < 2) return null;

      const parseLine = (line) => {
        let content = line.trim();
        if (content.startsWith("|")) content = content.substring(1);
        if (content.endsWith("|"))
          content = content.substring(0, content.length - 1);
        return content.split("|").map((cell) => cell.trim());
      };

      const headers = parseLine(lines[0]);
      const data = [];

      for (let i = 1; i < lines.length; i++) {
        const line = lines[i].trim();
        if (line.includes("---") || !line.includes("|")) continue;

        const values = parseLine(line);
        const rowObj = {};
        headers.forEach((header, index) => {
          // Values ko number me convert karne ki koshish karo chart ke liye
          const val = values[index] || "";
          rowObj[header] = isNaN(Number(val)) ? val : Number(val);
        });
        data.push(rowObj);
      }
      return data.length > 0 ? data : null;
    } catch (e) {
      return null;
    }
  };

  const parseLabeledList = (text) => {
    try {
      if (!text.includes("** *") || !text.match(/^\d+\./m)) return null;

      const lines = text.split("\n");
      const data = [];

      lines.forEach((line) => {
        if (!line.trim().match(/^\d+\./)) return;

        const rowObj = {};
        const regex = /\*\*(.*?)\:\*\*\s*(.*?)(?=\s*\*\*|$|,)/g;

        let match;
        let hasMatches = false;

        let cleanLine = line.replace(/^\d+\.\s*/, "");

        const parts = cleanLine.split("**");

        for (let i = 1; i < parts.length; i += 2) {
          const key = parts[i].replace(":", "").trim();
          let value = parts[i + 1] ? parts[i + 1].trim() : "";

          if (value.endsWith(",")) value = value.slice(0, -1).trim();

          if (key && value) {
            rowObj[key] = value;
            hasMatches = true;
          }
        }

        if (hasMatches) {
          data.push(rowObj);
        }
      });

      return data.length > 0 ? data : null;
    } catch (e) {
      console.error("List parsing error", e);
      return null;
    }
  };

  const tryParseTableData = (text) => {
    if (!text || typeof text !== "string") return null;
    const trimmed = text.trim();

    if (trimmed.startsWith("[") && trimmed.endsWith("]")) {
      try {
        const parsed = JSON.parse(trimmed);
        if (Array.isArray(parsed) && parsed.length > 0) return parsed;
      } catch (e) {}
    }

    if (
      trimmed.includes("|") &&
      trimmed.includes("\n") &&
      trimmed.includes("---")
    ) {
      const mdResult = parseMarkdownTable(trimmed);
      if (mdResult) return mdResult;
    }

    const listResult = parseLabeledList(trimmed);
    if (listResult) return listResult;

    return null;
  };

  const markdownComponents = {
    table: ({ node, ...props }) => (
      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          //   border: "1px solid",
          //   borderColor: "divider",
          my: 1,
          // pb:"0px",
          borderRadius: 2,
          bgcolor: "transparent",
          width: "100%",
          minWidth: "100%",
          "&::-webkit-scrollbar": {
            width: "2px",
            height: "2px",
          },
          "&::-webkit-scrollbar-track": {
            background: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor:
              mode === "dark" ? "rgba(255,255,255,0.2)" : "rgba(0,0,0,0.1)",
            borderRadius: "4px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor:
              mode === "dark" ? "rgba(255,255,255,0.3)" : "rgba(0,0,0,0.2)",
          },
        }}
      >
        <Table size="small" aria-label="markdown table" {...props} />
      </TableContainer>
    ),

    thead: ({ node, ...props }) => (
      <TableHead
        sx={{
          bgcolor:
            mode === "dark" ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.03)",
          whiteSpace: "nowrap",
        }}
        {...props}
      />
    ),

    tbody: ({ node, ...props }) => <TableBody {...props} />,

    tr: ({ node, ...props }) => (
      <TableRow
        sx={{
          "&:last-child td, &:last-child th": { border: 0 },
          whiteSpace: "nowrap",
        }}
        {...props}
      />
    ),

    th: ({ node, ...props }) => (
      <TableCell
        align="left"
        sx={{
          fontWeight: "bold",
          color: "text.primary",
          fontSize: "0.75rem",
          p: 1,
          borderBottom: "1px solid",
          borderColor: "divider",
          whiteSpace: "nowrap",
        }}
        {...props}
      />
    ),
    td: ({ node, ...props }) => (
      <TableCell
        align="left"
        sx={{
          color: "text.secondary",
          fontSize: "0.75rem",
          p: 1,
          borderBottom: "1px solid",
          borderColor: "divider",
          whiteSpace: "nowrap",
        }}
        {...props}
      />
    ),
    a: ({ node, ...props }) => (
      <a {...props} style={{ color: "#1565c0", textDecoration: "underline" }} />
    ),
  };

  const handleSessionClick = (sessionId) => {
    setActiveSessionId(sessionId);
    if (sessionId === "new_chat") return;

    getSessionHistory(userId, sessionId.toString());
    if (window.innerWidth < 600) setIsSidebarOpen(false);
  };

  useEffect(() => {
    scrollToBottom();
  }, [currentSession.messages, isTyping, activeSessionId, selectedFile]);

  const handleNewChat = () => {
    const newSessionId = "new_chat";

    const newSession = {
      id: newSessionId,
      title: "New Chat",
      messages: [
        {
          // id: Date.now(),
          // text: "Hello! I'm ready for a new task.",
          // sender: "bot",
          id: "hidden_init",
          text: "Hidden Init",
          sender: "bot",
          isHidden: true,
          type: "text",
          timestamp: new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          }),
        },
      ],
      // messages: [],
    };

    setSessions((prev) => {
      const filtered = prev.filter((s) => s.id !== "new_chat");
      return [newSession, ...filtered];
    });

    setActiveSessionId(newSessionId);
    setSearchQuery("");

    if (window.innerWidth < 600) setIsSidebarOpen(false);
  };

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [sessionToDelete, setSessionToDelete] = useState(null);

  const handleDeleteSession = (e, sessionId) => {
    e.stopPropagation();
    setSessionToDelete(sessionId);
    setDeleteDialogOpen(true);
  };
  const handleConfirmDelete = () => {
    if (!sessionToDelete) return;
    deleteSession(userId, sessionToDelete);

    const filtered = sessions.filter(
      (s) => String(s.id) !== String(sessionToDelete),
    );
    setSessions(filtered);

    if (
      String(activeSessionId) === String(sessionToDelete) &&
      filtered.length > 0
    ) {
      setActiveSessionId(filtered[0].id);
    } else if (filtered.length === 0) {
      handleNewChat();
    }
    setDeleteDialogOpen(false);
    setSessionToDelete(null);
  };
  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setSessionToDelete(null);
  };

  useEffect(() => {
    const historyData = getSessionHistoryReducer?.activeSessionData;

    if (historyData && historyData.sessionId) {
      setSessions((prevSessions) => {
        let isMatchFound = false;

        const updatedSessions = prevSessions.map((s) => {
          const localId = String(s.id).trim();
          const apiId = String(historyData.sessionId).trim();

          if (localId === apiId) {
            isMatchFound = true;
            return {
              ...s,
              messages: historyData.messages,
            };
          }
          return s;
        });

        return updatedSessions;
      });
    }
  }, [getSessionHistoryReducer?.activeSessionData]);

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
    }
    event.target.value = "";
  };

  const handleRemoveFile = () => {
    setSelectedFile(null);
  };

  const handleSend = async (textOverride = null) => {
    const textToSend = textOverride || inputValue;
    const fileToSend = selectedFile;

    if (!textToSend.trim() && !fileToSend) return;

    setIsTyping(true);

    let currentSessionId = activeSessionId;
    if (currentSessionId === "new_chat") {
      try {
        const newSessionData = await createNewSession(userId, "temp");

        if (newSessionData && newSessionData.id) {
          currentSessionId = String(newSessionData.id);
          setActiveSessionId(currentSessionId);
          setSessions((prev) => {
            const withoutNewChat = prev.filter((s) => s.id !== "new_chat");
            const newSession = {
              id: currentSessionId,
              title: "New Chat",
              messages: prev.find((s) => s.id === "new_chat")?.messages || [],
            };
            return [newSession, ...withoutNewChat];
          });
        } else {
          throw new Error("Session ID not found in response");
        }
      } catch (error) {
        setIsTyping(false);
        return;
      }
    } else {
      currentSessionId = String(currentSessionId);
    }

    const newMessage = {
      id: Date.now(),
      text: textToSend,
      sender: "user",
      type: fileToSend ? "file" : "text",
      fileName: fileToSend ? fileToSend.name : null,
      fileSize: fileToSend ? (fileToSend.size / 1024).toFixed(2) + " KB" : null,
      timestamp: new Date().toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      }),
    };

    setSessions((prevSessions) =>
      prevSessions.map((session) => {
        if (String(session.id) === String(currentSessionId)) {
          // const isFirstUserMsg = session.messages.length <= 1;
          const hasOnlyHidden =
            session.messages.length === 1 && session.messages[0].isHidden;
          const isFirstUserMsg = session.messages.length === 0 || hasOnlyHidden;
          let newTitle = session.title;

          if (isFirstUserMsg) {
            if (textToSend.trim()) {
              newTitle =
                textToSend.substring(0, 20) +
                (textToSend.length > 20 ? "..." : "");
            } else if (fileToSend) {
              newTitle = "File Attachment";
            }
          }

          return {
            ...session,
            title: newTitle,
            messages: [...session.messages, newMessage],
          };
        }
        return session;
      }),
    );

    setInputValue("");
    setSelectedFile(null);

    try {
      let promptToSend = textToSend;
      if (fileToSend) {
        promptToSend = `[User uploaded file: ${fileToSend.name}] ${textToSend}`;
      }

      const responseText = await sendMessage({
        userId: userId,
        sessionId: currentSessionId,
        message: promptToSend,
      });

      const botMessage = {
        id: Date.now() + 1,
        text: responseText,
        sender: "bot",
        type: "text",
        timestamp: new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        }),
      };

      setSessions((prevSessions) =>
        prevSessions.map((session) => {
          if (String(session.id) === String(currentSessionId)) {
            return {
              ...session,
              messages: [...session.messages, botMessage],
            };
          }
          return session;
        }),
      );
    } catch (error) {
      let displayMessage = "Oops! Something went wrong. Please try again.";

      // Check Status Code Directly Here
      if (error.response) {
        switch (error.response.status) {
          case 404:
            displayMessage = "🔴 Unable to connect to the MOBY.";
            break;
          case 500:
            displayMessage =
              "⚠️ Please refresh the page, there is some network issue.";
            break;
          case 503:
            displayMessage =
              "⚠️ Please refresh the page, there is some network issue";
            break;
          case 400:
            displayMessage =
              "❌ I couldn't understand that request. Please check your input.";
            break;
          case 401:
            displayMessage = "🔒 Your session has expired.";
            break;
          //   default:
          //     displayMessage =
          //       error.response.data?.message || "An unexpected error occurred.";
        }
      } else if (error.request) {
        displayMessage =
          "📡 No internet connection. Please check your network.";
      }
      const errorMessage = {
        id: Date.now() + 1,
        text: displayMessage,
        sender: "bot",
        type: "text",
        timestamp: new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        }),
      };

      setSessions((prevSessions) =>
        prevSessions.map((session) => {
          if (String(session.id) === String(currentSessionId)) {
            return {
              ...session,
              messages: [...session.messages, errorMessage],
            };
          }
          return session;
        }),
      );
    } finally {
      setIsTyping(false);
    }
  };

  const handleClearAllClick = (e) => {
    e.stopPropagation();
    setClearAllOpen(true);
  };
  const handleCloseClearAll = () => {
    setClearAllOpen(false);
  };

  const handleConfirmClearAll = async () => {
    setClearAllOpen(false);
    const success = await clearAllSessions(userId);
    if (success) {
      getAllSessions(userId);
      handleNewChat();
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        overflow: "hidden",
        borderRadius: "16px",
        bgcolor: "background.paper",
        // mt: "15px",
        fontFamily: "Arial, serif",
        "& .MuiTypography-root": { fontFamily: "Arial, serif" },
        "& .MuiInputBase-input": { fontFamily: "Arial, serif" },
      }}
    >
      {/* LEFT SIDEBAR */}
      <Box
        sx={{
          width: isSidebarOpen ? "180px" : "0px",
          opacity: isSidebarOpen ? 1 : 0,
          transition: "all 0.3s ease",
          borderRight: "1px solid",
          borderColor: "divider",
          // bgcolor: "background.default",
          bgcolor: "background.paper",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          whiteSpace: "nowrap",
        }}
      >
        <Box sx={{ p: 1.5, pb: 0.5 }}>
          <ListItemButton
            onClick={handleNewChat}
            sx={{
              border: "1px solid",
              borderColor: "divider",
              borderRadius: "10px",
              color: "#5b96f7",
              bgcolor: "background.paper",
              justifyContent: "center",
              gap: 0.5,
              mb: 1,
              minHeight: 28,
              "& .MuiTypography-root": { fontSize: "0.60rem" },
              "&:hover": { bgcolor: "action.hover", borderColor: "#5b96f7" },
            }}
          >
            <AddCircleOutlineRoundedIcon fontSize="small" />
            <Typography
              variant="body2"
              fontWeight={500}
              sx={{ fontSize: "0.75rem", lineHeight: 1.2 }}
            >
              New Chat
            </Typography>
          </ListItemButton>

          <Paper
            elevation={0}
            sx={{
              p: "0px 4px",
              display: "flex",
              alignItems: "center",
              bgcolor: "background.paper",
              border: "1px solid",
              borderColor: "divider",
              borderRadius: "8px",
            }}
          >
            <IconButton sx={{ p: "4px" }} aria-label="search" disabled>
              <SearchRoundedIcon
                sx={{ fontSize: 14, color: "text.disabled" }}
              />
            </IconButton>
            <InputBase
              sx={{
                ml: 1,
                flex: 1,
                fontSize: "0.9rem",
                color: "text.primary",
                fontFamily: "Arial, serif",
              }}
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            {searchQuery && (
              <IconButton sx={{ p: "8px" }} onClick={() => setSearchQuery("")}>
                <CloseRoundedIcon
                  sx={{ fontSize: 16, color: "text.secondary" }}
                />
              </IconButton>
            )}
          </Paper>
        </Box>

        {/* <Typography
          variant="caption"
          sx={{
            px: 2,
            pb: 0.5,
            pt: 0.5,
            color: "text.secondary",
            fontWeight: 600,
            fontSize: "0.7rem",
          }}
        >
          RECENT
        </Typography> */}
        {/* --- RECENT HEADER WITH CLEAR BUTTON --- */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 2,
            pb: 0.5,
            pt: 1.5,
          }}
        >
          <Typography
            variant="caption"
            sx={{
              color: "text.secondary",
              fontWeight: 600,
              fontSize: "0.7rem",
            }}
          >
            RECENT
          </Typography>

          {sessions.length > 1 && (
            <Tooltip title="Clear all sessions" placement="right">
              <IconButton
                size="small"
                onClick={handleClearAllClick}
                sx={{
                  padding: "2px",
                  color: "text.disabled",
                  transition: "0.2s",
                  "&:hover": {
                    color: "#ef5350",
                    bgcolor: "rgba(239, 83, 80, 0.1)",
                  },
                }}
              >
                <DeleteSweepRoundedIcon sx={{ fontSize: "1rem" }} />
              </IconButton>
            </Tooltip>
          )}
        </Box>

        <List
          sx={{
            flex: 1,
            overflowY: "auto",
            px: 0.5,
            "&::-webkit-scrollbar": {
              width: "2px",
            },
            "&::-webkit-scrollbar-track": {
              background: "transparent",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor:
                mode === "dark" ? "rgba(255,255,255,0.2)" : "rgba(0,0,0,0.1)",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor:
                mode === "dark" ? "rgba(255,255,255,0.3)" : "rgba(0,0,0,0.2)",
            },
          }}
        >
          {filteredSessions.length > 0 ? (
            filteredSessions.map((session) => (
              <ListItem key={session.id} disablePadding sx={{ mb: 0.5 }}>
                <ListItemButton
                  onClick={() => handleSessionClick(session.id)}
                  selected={activeSessionId === session.id}
                  sx={{
                    borderRadius: "6px",
                    "&.Mui-selected": {
                      bgcolor: "rgba(21, 101, 192, 0.15)",
                      color: "#1565c0",
                    },
                    "&.Mui-selected:hover": {
                      bgcolor: "rgba(21, 101, 192, 0.25)",
                    },
                    color: "text.primary",
                    "&:hover": {
                      bgcolor: "action.hover",
                      "& .delete-icon": { opacity: 1 },
                    },
                  }}
                >
                  <ListItemIcon sx={{ minWidth: "20px", color: "inherit" }} />

                  <ListItemText
                    primary={session.title}
                    primaryTypographyProps={{
                      fontSize: "0.75rem",
                      noWrap: true,
                      fontFamily: "Arial, serif",
                    }}
                  />
                  {session.id !== "new_chat" &&
                    activeSessionId !== session.id && (
                      <DeleteOutlineRoundedIcon
                        className="delete-icon"
                        fontSize="small"
                        sx={{
                          color: "#ef9a9a",
                          cursor: "pointer",
                          "&:hover": { color: "error.main" },
                          opacity: 0,
                          transition: "opacity 0.2s ease",
                        }}
                        onClick={(e) => handleDeleteSession(e, session.id)}
                      />
                    )}
                </ListItemButton>
              </ListItem>
            ))
          ) : (
            <Typography
              variant="caption"
              sx={{
                textAlign: "center",
                display: "block",
                color: "text.disabled",
                mt: 2,
              }}
            >
              No chats found
            </Typography>
          )}
        </List>
      </Box>

      {/* RIGHT CHAT AREA */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          height: "100%",
          position: "relative",
          transition: "width 0.3s ease",
          minWidth: 0,
          overflow: "hidden",
        }}
      >
        {/* HEADER */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            py: 0.75,
            px: 2,
            borderBottom: "1px solid",
            borderColor: "divider",
            bgcolor: "background.paper",
            zIndex: 1,
            minHeight: "50px",
            "&:hover .toggle-btn": {
              opacity: 1,
              transform: "translateX(0px)",
            },
          }}
        >
          {/* --- LEFT SECTION: TOGGLE & DIVIDER --- */}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Tooltip title={isSidebarOpen ? "Close Sidebar" : "Open Sidebar"}>
              <IconButton
                className="toggle-btn"
                onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                size="small"
                sx={{
                  color: "text.secondary",
                  p: 0,
                  opacity: 0,
                  transform: "translateX(-10px)",
                  transition: "all 0.3s ease",
                  ml: -2,

                  "&:hover": { color: "#5b96f7", bgcolor: "action.hover" },
                }}
              >
                {isSidebarOpen ? (
                  <ChevronLeftRoundedIcon sx={{ fontSize: "1.5rem" }} />
                ) : (
                  <ChevronRightRoundedIcon sx={{ fontSize: "1.5rem" }} />
                )}
              </IconButton>
            </Tooltip>

            {/* <Divider
              orientation="vertical"
              flexItem
              sx={{
                mx: 1.5,
                height: "12px",
                alignSelf: "center",
                borderColor: "divider",
              }}
            /> */}
          </Box>

          {/* --- CENTER SECTION: AVATAR & NAME --- */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              position: "absolute",
              left: "12%",
              transform: "translateX(-50%)",
            }}
          >
            <Box
              sx={{
                width: 32,
                height: 32,
                bgcolor: mode === "dark" ? "rgba(255,255,255,0.05)" : "#f5f7fa",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mr: 1.5,
                border: "1px solid",
                borderColor: "divider",
              }}
            >
              <img
                src={aiLogo}
                alt="Bot"
                style={{ width: "30px", height: "auto" }}
              />
            </Box>

            <Box>
              <Typography
                variant="subtitle2"
                fontWeight="700"
                sx={{
                  fontSize: "0.85rem",
                  color: "text.primary",
                  lineHeight: 1,
                  fontFamily: "Arial, serif",
                }}
              >
                MOBY Assistant
              </Typography>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{
                  display: "block",
                  fontSize: "0.7rem",
                  lineHeight: 1,
                  fontFamily: "Arial, serif",
                }}
              >
                {/* {currentSession.title} */}
                Ready to assist
              </Typography>
            </Box>
          </Box>

          {/* --- RIGHT SECTION --- */}
          <Box sx={{ ml: "auto" }}>
            <IconButton
              onClick={toggleColorMode}
              color="inherit"
              size="small"
              sx={{
                color: "text.secondary",
                transition: "transform 0.4s",
                "&:hover": {
                  bgcolor: "action.hover",
                  color: "text.primary",
                  transform: "rotate(180deg)",
                },
              }}
            >
              {mode === "dark" ? (
                <LightModeRoundedIcon fontSize="small" />
              ) : (
                <DarkModeRoundedIcon fontSize="small" />
              )}
            </IconButton>
          </Box>
        </Box>

        {/* --- MESSAGES AREA --- */}
        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            minHeight: 0,
            p: 0.6,
            bgcolor: "background.paper",
            display: "flex",
            flexDirection: "column",
            gap: 1,
            position: "relative",
            "&::-webkit-scrollbar": {
              width: "2px",
            },
            "&::-webkit-scrollbar-track": {
              background: "transparent",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor:
                mode === "dark" ? "rgba(255,255,255,0.2)" : "rgba(0,0,0,0.1)",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor:
                mode === "dark" ? "rgba(255,255,255,0.3)" : "rgba(0,0,0,0.2)",
            },
          }}
        >
          {/* HERO SECTION */}
          <Fade in={showHero} timeout={800} unmountOnExit>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                width: "100%",
                zIndex: 5,
                pointerEvents: showHero ? "auto" : "none",
              }}
            >
              <Box
                component="img"
                src={aiLogo}
                alt="MOBY"
                sx={{
                  height: 210,
                  width: "auto",
                  mb: 3,
                  objectFit: "contain",
                  filter: "drop-shadow(0 10px 20px rgba(0,0,0,0.15))",
                  transition: "transform 0.3s ease",
                  "&:hover": {
                    transform: "scale(1.05)",
                  },
                }}
              />

              <Typography
                variant="h6"
                fontWeight={800}
                color="text.primary"
                sx={{
                  fontFamily: "Arial, serif",
                }}
                gutterBottom
              >
                How can I help you today?
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  maxWidth: 360,
                  fontSize: "0.85rem",
                  fontFamily: "Arial, serif",
                }}
              >
                Ask me about inventory, production, or reports.
              </Typography>
            </Box>
          </Fade>

          {/* STANDARD CHAT LIST */}
          {!showHero && (
            <Fade in={!showHero} timeout={800}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                {/* {currentSession.messages.map((msg) => {
                  const isUser = msg.sender === "user";
                  const isFile = msg.type === "file";
                  if (msg.isHidden || msg.id === "hidden_init") return null;
                  return (
                    <Box
                      key={msg.id}
                      sx={{
                        display: "flex",
                        justifyContent: isUser ? "flex-end" : "flex-start",
                        alignItems: "flex-end",
                        gap: 1,
                        mb: 1,
                        maxWidth: "100%",
                        overflow: "hidden",
                      }}
                    >
                      {!isUser && (
                        <Avatar
                          src={aiLogo}
                          sx={{
                            width: 35,
                            height: 35,
                            bgcolor: "background.default",
                            border: "1px solid",
                            borderColor: "divider",
                            flexShrink: 0,
                            overflow: "hidden",
                          }}
                          imgProps={{
                            style: {
                              width: "200%",
                              height: "200%",
                              objectFit: "cover",
                              objectPosition: "50% 20%",
                              transform: "translateY(5%)",
                            },
                          }}
                        />
                      )}

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: isUser ? "flex-end" : "flex-start",
                          maxWidth: isUser ? "90%" : "100%",
                          minWidth: isUser ? "auto" : "300px",
                          overflow: "hidden",
                        }}
                      >
                        <Typography
                          variant="caption"
                          sx={{
                            mb: 0,
                            color: "text.secondary",
                            fontWeight: 600,
                            fontSize: "0.7rem",
                          }}
                        >
                          {isUser ? "You" : "MOBY"}
                        </Typography>

                        <Paper
                          elevation={0}
                          sx={{
                            p: isFile ? "8px 12px" : "12px 16px",
                            borderRadius: isUser
                              ? "18px 18px 4px 18px"
                              : "18px 18px 18px 4px",
                            bgcolor: isUser
                              ? "background.chatUser"
                              : "background.paper",
                            color: isUser
                              ? mode === "dark"
                                ? "common.black"
                                : "common.white"
                              : "text.primary",
                            boxShadow: isUser
                              ? "0 4px 12px rgba(91, 150, 247, 0.2)"
                              : "none",
                            border: isUser ? "none" : "1px solid",
                            borderColor: isUser ? "none" : "divider",
                            width: "fit-content",
                            maxWidth: "100%",
                            overflowX: "auto",
                            wordBreak: "break-word",
                          }}
                        >
                          {isFile ? (
                            <Box>
                              <Stack
                                direction="row"
                                spacing={1}
                                alignItems="center"
                                sx={{
                                  mb: msg.text ? 1 : 0,
                                  pb: msg.text ? 1 : 0,
                                  borderBottom: msg.text
                                    ? isUser
                                      ? "1px solid rgba(255,255,255,0.3)"
                                      : "1px solid"
                                    : "none",
                                  borderColor: "divider",
                                }}
                              >
                                <Box
                                  sx={{
                                    p: 1,
                                    bgcolor: isUser
                                      ? "rgba(255,255,255,0.2)"
                                      : "background.paper",
                                    borderRadius: "8px",
                                  }}
                                >
                                  <InsertDriveFileRoundedIcon
                                    fontSize="small"
                                    sx={{
                                      color: isUser
                                        ? "inherit"
                                        : "text.secondary",
                                    }}
                                  />
                                </Box>
                                <Box>
                                  <Typography
                                    variant="body2"
                                    fontWeight={600}
                                    sx={{ fontSize: "0.65rem" }}
                                  >
                                    {msg.fileName}
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    sx={{ opacity: 0.6, fontSize: "0.70rem" }}
                                  >
                                    {msg.fileSize || "Attachment"}
                                  </Typography>
                                </Box>
                              </Stack>
                              {msg.text && (
                                <Box
                                  sx={{
                                    "& p": { m: 0, mb: 0.5 },
                                    "& ul, & ol": { m: 0, pl: 2.5 },
                                    "& li": { mb: 0.5 },
                                    "& strong": { fontWeight: 700 },
                                    "& a": {
                                      color: "#1565c0",
                                      textDecoration: "underline",
                                    },
                                    fontSize: "0.75rem",
                                    lineHeight: 1.5,
                                    fontFamily: "Arial, sans-serif",
                                  }}
                                >
                                  <ReactMarkdown
                                    remarkPlugins={[remarkGfm]}
                                    components={markdownComponents}
                                    sx={{ fontFamily: "Arial, sans-serif" }}
                                  >
                                    {msg.text}
                                  </ReactMarkdown>
                                </Box>
                              )}
                            </Box>
                          ) : (
                            <Box
                              sx={{
                                "& p": { m: 0, mb: 0.5 },
                                "& ul, & ol": { m: 0, pl: 2.5 },
                                "& li": { mb: 0.5 },
                                "& strong": { fontWeight: 700 },
                                "& a": {
                                  color: isUser ? "inherit" : "#1565c0",
                                  textDecoration: "underline",
                                },
                                "& h1, & h2, & h3": {
                                  fontSize: "1rem",
                                  fontWeight: "bold",
                                  m: 0,
                                  mb: 1,
                                },
                                color: "inherit",
                                fontSize: "0.75rem",
                                lineHeight: 1.5,
                                fontFamily: "Arial, sans-serif",
                              }}
                            >
                              <ReactMarkdown
                                remarkPlugins={[remarkGfm]}
                                components={markdownComponents}
                                sx={{ fontFamily: "Arial, sans-serif" }}
                              >
                                {msg.text}
                              </ReactMarkdown>
                            </Box>
                          )}
                        </Paper>

                        <Typography
                          variant="caption"
                          sx={{
                            color: "text.disabled",
                            mt: 0.3,
                            fontSize: "0.65rem",
                            px: 0.3,
                          }}
                        >
                          {msg.timestamp}
                        </Typography>
                      </Box>

                      {isUser && (
                        <Avatar
                          sx={{
                            width: 30,
                            height: 30,
                            bgcolor: "rgba(21, 101, 192, 0.1)",
                            color: "#1565c0",
                            border: "2px solid",
                            borderColor: "background.paper",
                            boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
                            flexShrink: 0,
                          }}
                        >
                          <PersonRoundedIcon sx={{ fontSize: 15 }} />
                        </Avatar>
                      )}
                    </Box>
                  );
                })} */}

                {currentSession.messages.map((msg) => {
                  const isUser = msg.sender === "user";
                  const isFile = msg.type === "file";

                  let contentAnalysis = { type: "text" };
                  if (!isUser && !isFile && msg.text) {
                    const detection = detectResponseType(msg.text);

                    if (detection.type === "structured") {
                      contentAnalysis = detection;
                    }
                  }

                  const { type, chartData, dataKey } = contentAnalysis;
                  const showChart = !isUser && type === "structured";
                  if (msg.isHidden || msg.id === "hidden_init") return null;

                  return (
                    <Box
                      key={msg.id}
                      sx={{
                        display: "flex",
                        justifyContent: isUser ? "flex-end" : "flex-start",
                        alignItems: "flex-end",
                        gap: 1,
                        mb: 1,
                        maxWidth: "100%",
                        overflow: "hidden",
                      }}
                    >
                      {!isUser && (
                        <Avatar
                          src={miniIcon}
                          sx={{
                            width: 35,
                            height: 35,
                            bgcolor: "background.default",
                            border: "1px solid",
                            borderColor: "divider",
                            flexShrink: 0,
                            overflow: "hidden",
                          }}
                          imgProps={{
                            style: {
                              width: "130%",
                              height: "130%",
                              objectFit: "cover",
                              objectPosition: "50% 25%",
                              transform: "translateY(-1%)",
                            },
                          }}
                        />
                      )}

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: isUser ? "flex-end" : "flex-start",
                          maxWidth: isUser ? "90%" : "100%",
                          minWidth: isUser ? "auto" : "300px",
                          overflow: "hidden",
                        }}
                      >
                        <Typography
                          variant="caption"
                          sx={{
                            mb: 0,
                            color: "text.secondary",
                            fontWeight: 600,
                            fontSize: "0.7rem",
                          }}
                        >
                          {isUser ? "You" : "MOBY"}
                        </Typography>

                        <Paper
                          elevation={0}
                          sx={{
                            p: showChart
                              ? 0
                              : isFile
                                ? "8px 12px"
                                : "12px 16px",
                            // p: isFile ? "8px 12px" : "12px 16px",
                            borderRadius: isUser
                              ? "18px 18px 4px 18px"
                              : "18px 18px 18px 4px",
                            bgcolor: isUser
                              ? "background.chatUser"
                              : "background.paper",
                            color: isUser
                              ? mode === "dark"
                                ? "common.black"
                                : "common.white"
                              : "text.primary",
                            boxShadow: isUser
                              ? "0 4px 12px rgba(91, 150, 247, 0.2)"
                              : "none",
                            border: isUser ? "none" : "1px solid",
                            borderColor: isUser ? "none" : "divider",
                            width: "fit-content",
                            maxWidth: "100%",
                            // overflowX: "auto",
                            // wordBreak: "break-word",
                            overflow: "hidden",
                            wordBreak: "break-word",
                          }}
                        >
                          {isFile ? (
                            <Box>
                              <Stack
                                direction="row"
                                spacing={1}
                                alignItems="center"
                                sx={{
                                  mb: msg.text ? 1 : 0,
                                  pb: msg.text ? 1 : 0,
                                  borderBottom: msg.text
                                    ? isUser
                                      ? "1px solid rgba(255,255,255,0.3)"
                                      : "1px solid"
                                    : "none",
                                  borderColor: "divider",
                                }}
                              >
                                <Box
                                  sx={{
                                    p: 1,
                                    bgcolor: isUser
                                      ? "rgba(255,255,255,0.2)"
                                      : "background.paper",
                                    borderRadius: "8px",
                                  }}
                                >
                                  <InsertDriveFileRoundedIcon
                                    fontSize="small"
                                    sx={{
                                      color: isUser
                                        ? "inherit"
                                        : "text.secondary",
                                    }}
                                  />
                                </Box>
                                <Box>
                                  <Typography
                                    variant="body2"
                                    fontWeight={600}
                                    sx={{ fontSize: "0.65rem" }}
                                  >
                                    {msg.fileName}
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    sx={{ opacity: 0.6, fontSize: "0.70rem" }}
                                  >
                                    {msg.fileSize || "Attachment"}
                                  </Typography>
                                </Box>
                              </Stack>
                              {msg.text && (
                                <Box
                                  sx={{
                                    fontSize: "0.75rem",
                                    fontFamily: "Arial, sans-serif",
                                  }}
                                >
                                  <ReactMarkdown
                                    remarkPlugins={[remarkGfm]}
                                    components={markdownComponents}
                                  >
                                    {msg.text}
                                  </ReactMarkdown>
                                </Box>
                              )}
                            </Box>
                          ) : (
                            <Box
                              sx={{
                                "& p": { m: 0, mb: 0.5 },
                                "& ul, & ol": { m: 0, pl: 2.5 },
                                "& li": { mb: 0.5 },
                                "& strong": { fontWeight: 700 },
                                "& a": {
                                  color: isUser ? "inherit" : "#1565c0",
                                  textDecoration: "underline",
                                },
                                "& h1, & h2, & h3": {
                                  fontSize: "1rem",
                                  fontWeight: "bold",
                                  m: 0,
                                  mb: 1,
                                },
                                color: "inherit",
                                fontSize: "0.75rem",
                                lineHeight: 1.5,
                                fontFamily: "Arial, sans-serif",
                              }}
                            >
                              {type === "structured" ? (
                                <Box
                                  sx={{
                                    width: "100%",
                                    minWidth: "300px",
                                    mt: 0,
                                    p: 0,
                                  }}
                                >
                                  <UniversalChart
                                    data={chartData}
                                    dataKey={dataKey}
                                    title="Analysis"
                                    rawMarkdown={msg.text}
                                    markdownComponents={markdownComponents}
                                  />
                                </Box>
                              ) : (
                                <ReactMarkdown
                                  remarkPlugins={[remarkGfm]}
                                  components={markdownComponents}
                                  sx={{ fontFamily: "Arial, sans-serif" }}
                                >
                                  {msg.text}
                                </ReactMarkdown>
                              )}
                            </Box>
                          )}
                        </Paper>

                        <Typography
                          variant="caption"
                          sx={{
                            color: "text.disabled",
                            mt: 0.3,
                            fontSize: "0.65rem",
                            px: 0.3,
                          }}
                        >
                          {msg.timestamp}
                        </Typography>
                      </Box>

                      {isUser && (
                        <Avatar
                          sx={{
                            width: 30,
                            height: 30,
                            bgcolor: "rgba(21, 101, 192, 0.1)",
                            color: "#1565c0",
                            border: "2px solid",
                            borderColor: "background.paper",
                            boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
                            flexShrink: 0,
                          }}
                        >
                          <PersonRoundedIcon sx={{ fontSize: 15 }} />
                        </Avatar>
                      )}
                    </Box>
                  );
                })}

                {isTyping && (
                  <Box
                    sx={{
                      display: "flex",
                      gap: 1,
                      mb: 2,
                      alignItems: "flex-end",
                      px: 0,
                    }}
                  >
                    <Avatar
                      src={miniIcon}
                      sx={{
                        width: 35,
                        height: 35,
                        border: "1px solid",
                        borderColor: "divider",
                      }}
                      imgProps={{
                        style: {
                          width: "130%",
                          height: "130%",
                          objectFit: "cover",
                          objectPosition: "50% 25%",
                          transform: "translateY(-1%)",
                        },
                      }}
                    />
                    <Paper
                      elevation={0}
                      sx={{
                        p: "12px 16px",
                        borderRadius: "18px 18px 18px 4px",
                        bgcolor: "background.paper",
                        border: "1px solid",
                        borderColor: "divider",
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        height: "auto",
                        minHeight: "45px",
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: "text.secondary",
                          fontSize: "0.8rem",
                          fontWeight: 500,
                        }}
                      >
                        MOBY is thinking
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          gap: 0.5,
                          alignItems: "center",
                          mt: 0.5,
                        }}
                      >
                        <Box
                          sx={{
                            width: 6,
                            height: 6,
                            bgcolor: "text.secondary",
                            borderRadius: "50%",
                            animation:
                              "typingBounce 1.4s infinite ease-in-out both",
                            animationDelay: "0s",
                          }}
                        />
                        <Box
                          sx={{
                            width: 6,
                            height: 6,
                            bgcolor: "text.secondary",
                            borderRadius: "50%",
                            animation:
                              "typingBounce 1.4s infinite ease-in-out both",
                            animationDelay: "0.2s",
                          }}
                        />
                        <Box
                          sx={{
                            width: 6,
                            height: 6,
                            bgcolor: "text.secondary",
                            borderRadius: "50%",
                            animation:
                              "typingBounce 1.4s infinite ease-in-out both",
                            animationDelay: "0.4s",
                          }}
                        />
                      </Box>
                      <style>
                        {`
                            @keyframes typingBounce {
                                0%, 80%, 100% { 
                                transform: scale(0.6); 
                                opacity: 0.5; 
                                }
                                40% { 
                                transform: scale(1); 
                                opacity: 1; 
                                }
                            }
                            `}
                      </style>
                    </Paper>
                  </Box>
                )}
                <div ref={messagesEndRef} />
              </Box>
            </Fade>
          )}
        </Box>

        {/* --- INPUT AREA --- */}

        {
          // <Box
          //   sx={{
          //     p: 0.5,
          //     borderTop: "0.5px solid",
          //     borderColor: "divider",
          //     bgcolor: "background.paper",
          //   }}
          // >
          //   <input
          //     type="file"
          //     hidden
          //     ref={fileInputRef}
          //     onChange={handleFileSelect}
          //   />

          //   {selectedFile && (
          //     <Box
          //       sx={{
          //         display: "flex",
          //         alignItems: "center",
          //         justifyContent: "space-between",
          //         bgcolor:
          //           mode === "dark" ? "rgba(91, 150, 247, 0.1)" : "#f0f7ff",
          //         border: "1px dashed #f32525ff",
          //         borderRadius: "8px",
          //         p: 0.75,
          //         mb: 1,
          //       }}
          //     >
          //       <Stack direction="row" spacing={1} alignItems="center">
          //         <Box
          //           sx={{
          //             p: 0.5,
          //             bgcolor: "background.paper",
          //             borderRadius: "4px",
          //             display: "flex",
          //           }}
          //         >
          //           <InsertDriveFileRoundedIcon
          //             fontSize="small"
          //             sx={{ color: "#5b96f7" }}
          //           />
          //         </Box>
          //         <Box>
          //           <Typography
          //             variant="body2"
          //             fontWeight={600}
          //             sx={{ color: "text.primary", fontSize: "0.8rem" }}
          //           >
          //             {selectedFile.name}
          //           </Typography>
          //           <Typography
          //             variant="caption"
          //             sx={{ color: "text.secondary", fontSize: "0.7rem" }}
          //           >
          //             {(selectedFile.size / 1024).toFixed(2)} KB
          //           </Typography>
          //         </Box>
          //       </Stack>
          //       <IconButton size="small" onClick={handleRemoveFile}>
          //         <CloseRoundedIcon fontSize="small" />
          //       </IconButton>
          //     </Box>
          //   )}

          //   <Stack direction="row" spacing={1} alignItems="flex-end">
          //     <TextField
          //       fullWidth
          //       multiline
          //       maxRows={4}
          //       placeholder={
          //         selectedFile ? "Add a message..." : "Message MOBY..."
          //       }
          //       value={inputValue}
          //       onChange={(e) => setInputValue(e.target.value)}
          //       onKeyDown={(e) => {
          //         if (e.key === "Enter" && !e.shiftKey) {
          //           e.preventDefault();
          //           handleSend();
          //         }
          //       }}
          //       sx={{
          //         "& .MuiOutlinedInput-root": {
          //           borderRadius: "20px",
          //           backgroundColor: "background.paper",
          //           pl: 2,
          //           pr: 1,
          //           padding: "5px",
          //           paddingLeft: "10px",
          //           "& fieldset": { borderColor: "divider" },
          //           "&:hover fieldset": { borderColor: "text.secondary" },
          //           "&.Mui-focused fieldset": {
          //             borderColor: "#eb2c2cff",
          //             borderWidth: "1px",
          //           },
          //         },
          //         "& .MuiInputBase-input": {
          //           color: "text.primary",
          //           fontFamily: "Arial, serif",
          //           fontSize: "0.75rem",
          //           paddingLeft: "7px",
          //           "&::placeholder": {
          //             fontSize: "0.75rem",
          //             opacity: 0.7,
          //           },
          //         },
          //       }}
          //       InputProps={
          //         {
          //           /* startAdornment: (
          //         <InputAdornment position="start">
          //           <IconButton onClick={() => fileInputRef.current.click()}>
          //             <AttachFileRoundedIcon sx={{ transform: "rotate(45deg)" }} />
          //           </IconButton>
          //         </InputAdornment>
          //       ),
          //       */
          //         }
          //       }
          //     />
          //     <Box
          //       sx={{
          //         mt: 0,
          //       }}
          //       onClick={() => handleSend()}
          //     >
          //       <IconButton
          //         disabled={(!inputValue.trim() && !selectedFile) || isTyping}
          //         sx={{
          //           bgcolor:
          //             inputValue.trim() || selectedFile
          //               ? mode === "dark"
          //                 ? "#1e1e1e"
          //                 : "white"
          //               : "action.disabledBackground",
          //           color: "#f32525ff",

          //           width: "35px",
          //           height: "35px",
          //           transition: "0.2s",
          //           border:
          //             mode === "dark" ? "1px solid #ff4d4d" : "1px solid red",

          //           "&:hover": {
          //             cursor: "pointer",
          //             bgcolor: mode === "dark" ? "#2d2d2d" : "#f5f5f5",
          //           },

          //           "&.Mui-disabled": {
          //             bgcolor: "action.disabledBackground",
          //             color: "text.disabled",
          //             border: "1px solid transparent",
          //           },
          //         }}
          //       >
          //         <SendRoundedIcon
          //           fontSize="small"
          //           sx={{
          //             transform: "rotate(-45deg)",
          //             marginLeft: "1.5px",
          //             mt: -0.7,
          //           }}
          //         />
          //       </IconButton>
          //     </Box>
          //   </Stack>

          //   {!selectedFile && (
          //     <Stack
          //       direction="row"
          //       spacing={1}
          //       sx={{
          //         mt: 0.8,
          //         overflowX: "auto",
          //         p: 0,
          //         color: "text.primary",
          //         fontFamily: "Arial, serif",
          //         fontSize: "0.65rem",
          //         opacity: 0.7,
          //       }}
          //     >
          //       <SuggestionChip
          //         label="Check Inventory"
          //         onClick={() => handleSend("Check Inventory")}
          //       />
          //       <SuggestionChip
          //         label="Production Status"
          //         onClick={() => handleSend("What is the Production Status?")}
          //       />
          //     </Stack>
          //   )}
          // </Box>

          <ChatInput
            onSendMessage={(newText) => {
              // Yahan wo function call karein jo message bhejta hai (e.g., handleSend)
              handleSend(newText);
            }}
            mode={mode}
            // disabled={isLoading} // Agar loading state hai to pass karein
          />
        }

        {/* --- DELETE CONFIRMATION MODAL --- */}
        <Modal
          open={deleteDialogOpen}
          onClose={handleCloseDeleteDialog}
          aria-labelledby="delete-modal-title"
        >
          <Box sx={deleteStyle}>
            <Typography
              id="delete-modal-title"
              sx={{
                fontSize: "1rem",
                fontWeight: 400,
                color: "text.primary",
                mb: 3,
              }}
            >
              Are you sure you want to delete?
            </Typography>

            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                variant="outlined"
                color="info"
                size="small"
                onClick={handleCloseDeleteDialog}
                sx={{
                  textTransform: "capitalize",
                  borderColor: "#1A73E8",
                  color: "#1A73E8",
                  fontFamily: "Arial, serif",
                }}
              >
                Cancel
              </Button>

              <Button
                variant="contained"
                color="error"
                size="small"
                onClick={handleConfirmDelete}
                sx={{
                  ml: 1,
                  textTransform: "capitalize",
                  color: "#fff",
                  bgcolor: "#F44335",
                  fontFamily: "Arial, serif",
                  "&:hover": { bgcolor: "#D32F2F" },
                }}
              >
                Delete
              </Button>
            </Box>
          </Box>
        </Modal>
        {/* --- CLEAR ALL HISTORY MODAL --- */}
        <Modal
          open={clearAllOpen}
          onClose={handleCloseClearAll}
          aria-labelledby="clear-all-modal-title"
        >
          <Box sx={deleteStyle}>
            <Typography
              id="clear-all-modal-title"
              sx={{
                fontSize: "1rem",
                fontWeight: 400,
                color: "text.primary",
                mb: 1,
              }}
            >
              Are you sure you want to delete ALL chat history?
            </Typography>

            <Typography
              variant="caption"
              sx={{
                display: "block",
                color: "text.secondary",
                mb: 3,
                lineHeight: 1.4,
              }}
            >
              This action will remove all conversations permanently. This cannot
              be undone.
            </Typography>

            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                variant="outlined"
                color="info"
                size="small"
                onClick={handleCloseClearAll}
                sx={{
                  textTransform: "capitalize",
                  borderColor: "#1A73E8",
                  color: "#1A73E8",
                  fontFamily: "Arial, serif",
                }}
              >
                Cancel
              </Button>

              <Button
                variant="contained"
                color="error"
                size="small"
                onClick={handleConfirmClearAll}
                sx={{
                  ml: 1,
                  textTransform: "capitalize",
                  color: "#fff",
                  bgcolor: "#F44335",
                  fontFamily: "Arial, serif",
                  "&:hover": { bgcolor: "#D32F2F" },
                }}
              >
                Delete All
              </Button>
            </Box>
          </Box>
        </Modal>
      </Box>
    </Box>
  );
};
const SuggestionChip = ({ label, onClick }) => (
  <Chip
    label={label}
    onClick={onClick}
    variant="outlined"
    size="small"
    sx={{
      borderColor: "divider",
      color: "text.secondary",
      bgcolor: "background.paper",
      fontSize: "0.7rem",
      height: 22,
      cursor: "pointer",
      fontFamily: "Arial, serif",
      px: 0.75,
      flexShrink: 0,
      "&:hover": { bgcolor: "action.hover", borderColor: "text.primary" },
    }}
  />
);

const mapStateToProps = (state) => ({
  getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
  getAllSessionsReducer: state.getAllSessionsReducer,
  getSessionHistoryReducer: state.getSessionHistoryReducer,
});

const mapDispatchToProps = (dispatch) => ({
  getSubModulesByRoleId: (roleId, jwtToken) =>
    dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  sendMessage: (data) => dispatch(sendMessage(data)),
  getAllSessions: (userId) => dispatch(getAllSessions(userId)),
  createNewSession: (userId, newSessionId) =>
    dispatch(createNewSession(userId, newSessionId)),
  getSessionHistory: (userId, sessionId) =>
    dispatch(getSessionHistory(userId, sessionId)),
  deleteSession: (userId, sessionId) =>
    dispatch(deleteSession(userId, sessionId)),
  clearAllSessions: (userId) => dispatch(clearAllSessions(userId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChatPageCopy);
